import React from "react";

function DocumentsIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 25.593 19.194" className={className}>
      <path
        d="M7.369,24.979h16a4.8,4.8,0,0,0,4.8-4.8H2.571a4.8,4.8,0,0,0,4.8,4.8Zm16-3.2h1.6v1.6h-1.6Zm3.2-16H4.17l-1.6,12.8H28.163Z"
        transform="translate(-2.571 -5.784)"
      />
    </svg>
  );
}

export { DocumentsIcon };
